export enum RequestCardsRoute {
  Order = 'order',
  Confirmation = 'confirmation',
}
